import api from '.';

export const consulta = (uuid) => api.get(`/lancamento/editar/${uuid}`);

export const editar = (lancamento) => api.post('/lancamento/editar', lancamento);

export const paraBaixar = (selectedUUIDs) => api.post('/lancamento/lancamentosParaBaixar', selectedUUIDs);

export const baixas = (dados) => api.post('/lancamento/baixas', dados);

export const baixar = (lancamento) => api.post('/lancamento/baixar', lancamento);

export const cadastrar = (lancamento) => api.post('/lancamento/cadastrar', lancamento);

export const deletar = (lancamento) => api.post('/lancamento/deletar', lancamento);

export const listar = (start, size, filters, filtersMode, globalFilter, sorting, tipo) =>
    api.get(`/lancamento/listar/`, {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            tipo,
        },
    });

export const listarObj = ({ start, size, filters, filtersMode, globalFilter, sorting, tipo }) =>
    api.get(`/lancamento/listar/`, {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            tipo,
        },
    });

export const estornar = (lancamentos) => api.post('/lancamento/estornar', lancamentos);

export const listarBaixas = (start, size, filters, filtersMode, globalFilter, sorting, tipo, uuid) =>
    api.get(`/lancamento/listarBaixas/`, {
        params: { start, size, filters, filtersMode, globalFilter, sorting, tipo, uuid },
    });

export const relatorio = (url, pessoasFiltrados) =>
    api.post(`/lancamento/relatorio/?${url.toString()}`, pessoasFiltrados, {
        responseType: 'arraybuffer',
    });
export const relatorioLancamentosBaixados = (url, pessoasFiltrados) =>
    api.post(`/lancamento/relatorioLancamentosBaixados/?${url.toString()}`, pessoasFiltrados, {
        responseType: 'arraybuffer',
    });
export const recibos = (url, pessoasFiltrados) =>
    api.post(`/lancamento/recibos/?${url.toString()}`, pessoasFiltrados, {
        responseType: 'arraybuffer',
    });

export const extrato = (url, obj = {}) =>
    api.post(`/lancamentoConta/extrato/?${url.toString()}`, obj, { responseType: 'arraybuffer' });

/* rotina de comprovantes */
export const listarComprovantes = (start, size, filters, filtersMode, globalFilter, sorting, uuid) =>
    api.get('/lancamento/listarComprovantes', {
        params: {
            start,
            size,
            filters,
            filtersMode,
            globalFilter,
            sorting,
            uuid,
        },
    });
export const createOrEditComprovante = async (objeto) => {
    try {
        const { data } = await api.post('/lancamento/createOrEditComprovante', objeto, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return data;
    } catch (error) {
        return error;
    }
};
